import { render } from "./App.vue?vue&type=template&id=54b3564b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=54b3564b&lang=scss"
script.render = render

export default script